export const theme = {
    primaryDark: '#003E6D',
    primaryLight: '#32FCB3',
    secondaryLight: '#009999',
    secondaryDark: '#232332',
    alternative: '#FF6584',
    white: '#ffffff',
}